import { useQuery } from '@tanstack/react-query';
import { getPractices } from 'api/methodologies';
import { practicesKeys } from 'api/queryKeys';

export const usePracticesQuery = (methodologyIds?: number[]) => {
  return useQuery({
    queryKey: practicesKeys.all(methodologyIds),
    queryFn: () =>
      getPractices({
        methodology_ids: methodologyIds?.length ? methodologyIds : undefined
      }).then((res) => res.data ?? []),
    enabled: true
  });
};
